import React from 'react';
import { motion } from 'framer-motion';

const About = () => {
  return (
    <section id="about" className="section about">
      <div className="container">
        <motion.h2 
          className="section-title"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          style={{ color: 'white' }}
        >
          About Sanchiti's Fitness Studio
        </motion.h2>
        
        <motion.div 
          className="about-content"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <div className="about-text">
            <h3 style={{ marginBottom: '1rem', fontSize: '1.5rem' }}>🙏 Welcome to Our Sacred Space</h3>
            <p style={{ marginBottom: '1rem' }}>
              At Sanchiti's Fitness Studio, we believe that yoga is not just a physical practice but a journey 
              of self-discovery and transformation. Our studio provides a serene and welcoming environment 
              where practitioners of all levels can explore the ancient wisdom of yoga.
            </p>
            <p style={{ marginBottom: '1rem' }}>
              Founded with the vision of bringing authentic yoga practices to our community, we offer traditional 
              Hatha, Vinyasa, Ashtanga, and restorative yoga classes. Our experienced instructors guide you 
              through each asana with mindfulness and precision, ensuring both safety and spiritual growth.
            </p>
            <p style={{ marginBottom: '1rem' }}>
              Whether you're a beginner taking your first steps on the mat or an advanced practitioner deepening 
              your practice, our diverse range of classes and personalized approach ensures that everyone finds 
              their perfect path to wellness.
            </p>
            <p>
              Join us in this beautiful journey of mind, body, and spirit integration. Experience the 
              transformative power of yoga in our peaceful studio where ancient traditions meet modern wellness.
            </p>
          </div>
          
          <motion.div 
            className="about-image"
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.3 }}
          >
            🧘‍♀️
          </motion.div>
        </motion.div>

        <motion.div 
          style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', 
            gap: '2rem', 
            marginTop: '3rem' 
          }}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          viewport={{ once: true }}
        >
          <div style={{ textAlign: 'center', padding: '2rem', background: 'rgba(255,255,255,0.1)', borderRadius: '15px' }}>
            <h3 style={{ fontSize: '2rem', marginBottom: '1rem' }}>🏆</h3>
            <h4 style={{ marginBottom: '0.5rem' }}>Expert Instructors</h4>
            <p>Certified yoga teachers with years of experience in traditional and modern yoga practices.</p>
          </div>
          
          <div style={{ textAlign: 'center', padding: '2rem', background: 'rgba(255,255,255,0.1)', borderRadius: '15px' }}>
            <h3 style={{ fontSize: '2rem', marginBottom: '1rem' }}>🏠</h3>
            <h4 style={{ marginBottom: '0.5rem' }}>Peaceful Environment</h4>
            <p>A tranquil space designed to promote relaxation, mindfulness, and spiritual growth.</p>
          </div>
          
          <div style={{ textAlign: 'center', padding: '2rem', background: 'rgba(255,255,255,0.1)', borderRadius: '15px' }}>
            <h3 style={{ fontSize: '2rem', marginBottom: '1rem' }}>👥</h3>
            <h4 style={{ marginBottom: '0.5rem' }}>Community Focus</h4>
            <p>Building a supportive community where everyone feels welcome and encouraged to grow.</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
